import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./i18n";

// Déterminer le basename pour les déploiements en sous-répertoire
const getBasename = () => {
  const path = window.location.pathname;
  const segments = path.split("/").filter(Boolean);
  if (
    window.location.hostname === "preview.maelcorp.com" &&
    segments.length > 0
  ) {
    return `/${segments[0]}`;
  }
  return ""; // Pour localhost, maelcorp.com à la racine, ou autres
};

const root = createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter basename={getBasename()}>
    <App />
  </BrowserRouter>
);
